import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { Validators, UntypedFormGroup, FormControl } from '@angular/forms';
import { LocalStorageService } from '../shared/local-storage.service';
import { LookupItem } from '../shared/lookup-item.model';
import { lookupItemValidator } from '../shared/trip-validator.model';
import { LookupDataService } from '../shared/lookup-data.service';
import { Observable } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-add-species-dialog',
    templateUrl: './add-species-dialog.component.html',
    styleUrls: ['./add-species-dialog.component.css'],
    standalone: false
})
export class AddSpeciesDialogComponent implements OnInit {

  speciesList: LookupItem[] = [];
  filteredSpecies!: Observable<LookupItem[]>;

  form: UntypedFormGroup = new UntypedFormGroup({
    species: new FormControl<LookupItem | string>('', [Validators.required, lookupItemValidator()])
  });

  isEditing: boolean = false;

  constructor(
    public dataSync: LocalStorageService,
    private lookup: LookupDataService,
    public dialogRef: MatDialogRef<AddSpeciesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { species: LookupItem, filterOption: 'Combined' | 'HMS' | 'Groundfish' | 'Trawl' }
  ) { }

  ngOnInit(): void {
    this.isEditing = this.data.species != null;

    let tempList: LookupItem[] = [];

    // Decide which list to load based on filterOption
    this.lookup.getSpeciesObservable(this.data.filterOption).subscribe((getSpecies: LookupItem[]) => {
      if (this.data.filterOption === 'HMS') tempList = LookupDataService._hmsSetSpecies;
      else if (this.data.filterOption === 'Groundfish' || this.data.filterOption === 'Trawl') tempList = getSpecies;
      else tempList = getSpecies.concat(LookupDataService._hmsSetSpecies);


      tempList = tempList.filter(species => !this.dataSync.current_user().favoriteSpecies.some(fav => fav.name === species.name));

      this.speciesList = tempList.sort((a, b) => a.name.localeCompare(b.name));
      this.filteredSpecies = this.form.get('species')!.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.speciesList.slice())
      );

      if (this.isEditing) {
        this.form.patchValue({
          species: this.data.species
        });
      }
    });
  }

  // Function to display species name in the input box
  displaySpecies(item: LookupItem): string {
    return item ? item.name : '';
  }

  // Filtering function for autocomplete
  private _filter(name: string): LookupItem[] {
    const filterValue = name.toLowerCase();
    return this.speciesList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  onCancelOrDelete(): void {
    if (this.isEditing) {
      this.dialogRef.close('delete');
    } else {
      this.dialogRef.close();
    }
  }

  addSpecies(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
